import { createContext, useContext } from 'react';

export const EvidenceIssueContext = createContext<string | undefined>(
  undefined,
);

export const useEvidenceIssueName = (): string | undefined =>
  useContext(EvidenceIssueContext);
